const publics = [
{
	path: '/coupons',
	name: 'coupons',
	component: _ => import("@/pages/public/coupons.vue"),
	meta: {
		title: '选择优惠劵'
	},
},
{
	path: '/registration',
	name: 'registration',
	component: _ => import("@/pages/registration/index.vue"),
	meta: {
		title: '登记用户信息'
	},
},
]
export default publics;
